import dayjs from "dayjs";
import { CUSTOM, DEFAULT_TIME } from "../constant/ReportConstants";

export const getReportDefaultDateFilter = locationSettings => {
  const saved = locationSettings?.REPORT_SETTINGS || {};
  const filter = saved.defaultDateFilter;

  if (filter === CUSTOM) {
    const raw = saved.defaultDateRange;
    if (Array.isArray(raw) && raw.length === 2) {
      const [start, end] = raw.map(d => dayjs(d));
      if (start.isValid() && end.isValid()) {
        return { filter: CUSTOM, range: [start, end] };
      }
    }
    return { filter: DEFAULT_TIME, range: null };
  }

  if (filter) return { filter, range: null };
  return { filter: DEFAULT_TIME, range: null };
};
